import { apiFetch } from "./client";
import type { Page, Site } from "./types";
import type { ListParams } from "./customers";

export interface SitePayload {
  site_code: string;
  name: string;
  address?: string | null;
  postcode?: string | null;
  timezone?: string;
  is_depot?: boolean;
  bays_count?: number;
  color?: string | null;
}

export async function listSites(params: ListParams = {}): Promise<Page<Site>> {
  const qs = new URLSearchParams();
  if (params.limit !== undefined) qs.set("limit", String(params.limit));
  if (params.offset !== undefined) qs.set("offset", String(params.offset));
  const query = qs.toString();
  return apiFetch(`/sites${query ? `?${query}` : ""}`);
}

export async function createSite(data: SitePayload): Promise<Site> {
  return apiFetch("/sites", { method: "POST", body: JSON.stringify(data) });
}

export async function getSite(id: number): Promise<Site> {
  return apiFetch(`/sites/${id}`);
}

export async function updateSite(id: number, data: Partial<SitePayload>): Promise<Site> {
  return apiFetch(`/sites/${id}`, { method: "PUT", body: JSON.stringify(data) });
}

export async function deleteSite(id: number): Promise<unknown> {
  return apiFetch(`/sites/${id}`, { method: "DELETE" });
}
